import {useEffect, useState} from "react";

export const DataTable = ({data}) => {
    const [columns, setColumns] = useState(null);

    useEffect(() => {
        if (data) {
            setColumns(Object.keys(data[0]));
        }
    }, [data]);

    const hashColumn = (columns) => {
        return columns.find(column => column === 'hash');
    }

    if (columns) {
        return (
            <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-gray-200">
                    <thead>
                    <tr>
                        {columns.map((column, index) => (
                            <th className={`px-4 py-2 text-left text-gray-600 font-semibold ${column === 'hash' ? 'hidden' : ''}`} key={index}>
                                {column}
                            </th>
                        ))}
                    </tr>
                    </thead>
                    <tbody>
                    {data.map((row, rowIndex) => (
                        <tr key={"row_" + rowIndex}>
                            {columns.map((col, colIndex) => (
                                <td key={rowIndex + "_" + colIndex} className={`border px-4 py-2 ${col === 'hash' ? 'hidden' : ''}`}>
                                    <>
                                        {hashColumn(columns) && (
                                            <a href={`https://app.carzelle.com/cars/edit/${row[hashColumn(columns)]}`} rel="noreferrer" target="_blank">{row[col]}</a>
                                        )}

                                        {!hashColumn(columns) && (
                                            <div>{row[col]}</div>
                                        )}
                                    </>
                                </td>
                            ))}
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        );
    }
}